import React from "react";

import { styled } from "@mui/system";
import { MenuItem, Select } from "@mui/material";

const StyledContainer = styled("div")(({ fullWidth }) => ({
  margin: "8px 0px",
  width: "100%",
  maxWidth: fullWidth ? "100%" : "16rem",
}));
const StyledSelect = styled(Select)(() => ({
  display: "flex",
  backgroundColor: "white",
  width: "100%",
  "& .MuiSelect-select": {
    whiteSpace: "normal",
    wordBreak: "break-word",
    lineHeight: 1.45,
    paddingTop: "10px",
    paddingBottom: "10px",
    minHeight: "1.45em",
  },
}));

const SingleSelect = (props) => {
  const {
    id,
    name,
    value,
    label,
    placeholder,
    handleChange,
    menuItems,
    defaultSelected,
    onBlur,
    disabled,
    hideNoneOption = false,
    fullWidth = false,
  } = props;
  const selectProps = {
    id,
    name,
    value,
    label,
  };
  return (
    <StyledContainer fullWidth={fullWidth}>
      <StyledSelect
        {...selectProps}
        multiline
        defaultValue={defaultSelected}
        displayEmpty
        renderValue={(selected) => {
          return selected.label || placeholder;
        }}
        MenuProps={{
          PaperProps: {
            sx: {
              maxHeight: 320,
            },
          },
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "left",
          },
          transformOrigin: {
            vertical: "top",
            horizontal: "left",
          },
        }}
        onChange={handleChange}
        onBlur={onBlur}
        disabled={disabled}
      >
        {!hideNoneOption && (
          <MenuItem value={{}}>
            <em>None</em>
          </MenuItem>
        )}
        {menuItems.map((menuItem) => (
          <MenuItem
            key={menuItem.id}
            value={menuItem}
            sx={{
              whiteSpace: "normal",
              wordBreak: "break-word",
              lineHeight: 1.45,
              py: 1.25,
            }}
          >
            {menuItem.label}
          </MenuItem>
        ))}
      </StyledSelect>
    </StyledContainer>
  );
};

export default SingleSelect;
